import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, createStyles } from '@mui/styles'
// import { SvgIconProps } from '@mui/material/SvgIcon'

import List from '@mui/material/List'

import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Collapse from '@mui/material/Collapse'

import IconExpandLess from '@mui/icons-material/ExpandLess'
import IconExpandMore from '@mui/icons-material/ExpandMore'

import AppMenuItemComponent from './appmenucomponent'
import RightAppMenuItemComponent from './rightappmenucomponent'

// React runtime PropTypes
export const AppMenuItemPropTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  Icon: PropTypes.elementType,
  items: PropTypes.array,
  isButton: PropTypes.bool
}

const RightAppMenuItem = props => {
  const { component, isButton, name, link, onClick, Icon, items = [], state } = props
  const classes = useStyles()
  const isExpandable = items && items.length > 0
  const [open, setOpen] = React.useState(false)

  function handleClick() {
    setOpen(!open)
  }

  const MenuItemRoot = (
    <RightAppMenuItemComponent isButton={!!Icon ? true : isButton ? true : false} className={classes.menuItem} link={link} onClick={!!onClick ? onClick : handleClick} state={state}>
      {!!component && (component)}
      {(!component && !!Icon) && (
        <ListItemIcon className={classes.menuItemIcon}>
          <Icon />
        </ListItemIcon>
      )}
      {!component && <ListItemText primary={name} />}
      {(!component && isExpandable && !open) && <IconExpandMore />}
      {(!component && isExpandable && open) && <IconExpandLess />}
    </RightAppMenuItemComponent>
  )

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Divider />
      <List component="div" disablePadding>
        {items.map((item, index) => (
          <RightAppMenuItem {...item} key={index} />
        ))}
      </List>
    </Collapse>
  ) : null

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  )
}

const useStyles = makeStyles(theme =>
  createStyles({
    menuItem: {
      '&.active': {
        background: 'rgba(0, 0, 0, 0.08)',
        '& .MuiListItemIcon-root': {
          color: 'grey',
        },
      },
    },
    menuItemIcon: {
      color: '#f47920',
    },
  }),
)

export default RightAppMenuItem
